import React, { useState } from "react"
import { motion } from "framer-motion"
import styled from "styled-components"
import tw from "twin.macro"
import NavigationBar from "../components/Navbar"
import Footer from "../components/footer"
import NewsletterStrip from "../components/newsletterStrip"

const Column = tw.div`flex flex-col items-center`
const HeaderContent = tw.div``

const FAQSContainer = tw.dl`mt-3 max-w-4xl relative`
const FAQ = tw.div`cursor-pointer select-none mt-5 px-8 sm:px-10 py-5 sm:py-4 rounded-lg text-gray-800 hover:text-gray-900 bg-gray-200 hover:bg-gray-300 transition duration-300`
const Question = tw.dt`flex justify-between items-center`
const QuestionText = tw.span`text-lg prose lg:text-xl font-semibold`
const QuestionToggleIcon = motion.custom(styled.span`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`)
const Answer = motion.custom(
  tw.dd`pointer-events-none text-lg prose sm:text-base leading-relaxed`
)

const FaqSection = ({
  faqs = [
    {
      question: "Is your content free of cost?",
      answer: "Yes, our content is completely free of cost.",
    },
    {
      question: "Is your content designed for beginners or advanced learners?",
      answer:
        "We have designed content for both types of audiences - beginners as well as advanced learners.",
    },
    {
      question: "Is your content designed for students or professionals?",
      answer:
        "We have designed content from industry and interview point of view. Hence it will benefit both students and professionals working on software projects or preparing for an interview.",
    },
    {
      question: "What will we get after subscribing to the newsletter?",
      answer:
        "Well designed content will be delivered weekly in the domain of Data Structure and Algorithms, Machine Learning, and System Design.",
    },
    {
      question:
        "Do you also provide the content in pre-recorded video or live video or podcast format?",
      answer:
        "Currently, we are providing text based guided content with in-depth explanations. Later we will extend it to other formats like pre-recorded videos or live videos or podcasts.",
    },
    {
      question:
        "What should the learners know before starting on enjoyalgorithms.com?",
      answer:
        "We expect learners to know the fundamentals of programming like data types, variables, loops, functions, etc.",
    },
  ],
}) => {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null)

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null)
    else setActiveQuestionIndex(questionIndex)
  }

  return (
    <div>
      <Column>
        <HeaderContent>
          <div className="text-3xl font-bold prose text-center">
            Frequently Asked Questions
          </div>
        </HeaderContent>
        <FAQSContainer>
          {faqs.map((faq, index) => (
            <FAQ
              key={index}
              onClick={() => {
                toggleQuestion(index)
              }}
              className="mx-3 group"
            >
              <Question>
                <QuestionText>{faq.question}</QuestionText>
                <QuestionToggleIcon
                  variants={{
                    collapsed: { rotate: 0 },
                    open: { rotate: -180 },
                  }}
                  initial="collapsed"
                  animate={activeQuestionIndex === index ? "open" : "collapsed"}
                  transition={{
                    duration: 0.02,
                    ease: [0.04, 0.62, 0.23, 0.98],
                  }}
                ></QuestionToggleIcon>
              </Question>
              <Answer
                variants={{
                  open: { opacity: 1, height: "auto", marginTop: "16px" },
                  collapsed: { opacity: 0, height: 0, marginTop: "0px" },
                }}
                initial="collapsed"
                animate={activeQuestionIndex === index ? "open" : "collapsed"}
                transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
              >
                {faq.answer}
              </Answer>
            </FAQ>
          ))}
        </FAQSContainer>
      </Column>
    </div>
  )
}

export default FaqSection
